var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.096 11.5173C20.2405 11.437 20.3301 11.2847 20.3301 11.1194C20.3301 10.9541 20.2405 10.8017 20.096 10.7215L18.0181 9.56707C13.9243 7.29275 9.60883 5.44274 5.13888 4.04588L4.53338 3.85666C4.39516 3.81347 4.24463 3.83862 4.12796 3.92439C4.01128 4.01017 3.94238 4.14634 3.94238 4.29116V9.52614C3.94238 9.76825 4.1319 9.968 4.37367 9.98072L5.29288 10.0291C7.53401 10.1471 9.76146 10.451 11.9522 10.9379L12.1692 10.9861C12.2175 10.9968 12.2384 11.0165 12.25 11.0322C12.2647 11.052 12.2762 11.0824 12.2762 11.1194C12.2762 11.1564 12.2647 11.1868 12.25 11.2066C12.2384 11.2222 12.2175 11.242 12.1692 11.2527L11.9523 11.3009C9.76147 11.7878 7.534 12.0917 5.29286 12.2097L4.37367 12.2581C4.1319 12.2708 3.94238 12.4705 3.94238 12.7126V17.9476C3.94238 18.0924 4.01128 18.2286 4.12796 18.3144C4.24463 18.4002 4.39516 18.4253 4.53338 18.3821L5.13889 18.1929C9.60883 16.796 13.9243 14.946 18.0181 12.6717L20.096 11.5173Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.bce939b69f464b05cef87721df398559.svg";
export { ForwardRef as ReactComponent };